//@flow
import React, { Component } from 'react';
import styled from 'styled-components/macro';

type Props = {
  handleChange: (values: {
    startDate: ?moment$Moment,
    endDate: ?moment$Moment
  }) => void,
  startDate: ?moment$Moment,
  endDate: ?moment$Moment,
  label: string
};

const DateOptionButton = styled.button`
  background-color: ${props => props.theme.blue};
  color: white;
  height: 50px;
  text-transform: uppercase;
  font-weight: 600;
  cursor: pointer;
  flex: 1;
`;

export default class DateOption extends Component<Props> {
  handleSelect = () => {
    this.props.handleChange({
      startDate: this.props.startDate,
      endDate: this.props.endDate
    });
  };

  render() {
    return (
      <DateOptionButton onClick={this.handleSelect}>
        {this.props.label}
      </DateOptionButton>
    );
  }
}
